module.exports = __webpack_public_path__ + "static/media/favourite_fill_black_border.998c24fc.svg";